import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, effect, Inject, viewChildren } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Address, Zone } from '@domains';
import { MapComponent } from '@rspl-map';
import { Destructible, FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';
import { take } from 'rxjs';

import { SaveZoneDialogComponent } from '../save-zone-dialog/save-zone-dialog.component';

export interface PreviewZoneChangeData {
  minus: number;
  plus: number;
  plusZips: string[];
  minusZips: string[];
  commonZips: string[];
  day: string;
  address: Address;
  schedule: Zone;
  zone: Zone;
}

@Component({
  selector: 'app-preview-zone-change-dialog',
  templateUrl: './preview-zone-change-dialog.component.html',
  styleUrls: ['./preview-zone-change-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    MatDialogActions,
    FxLayoutDirective,
    FxLayoutAlignDirective,
    MatButton,
    MapComponent,
    ReactiveFormsModule,
    MatIcon,
    FxLayoutDirective,
    FxLayoutGapDirective,
    FxLayoutAlignDirective,
    FxFlexDirective,
  ],
})
export class PreviewZoneChangeDialogComponent extends Destructible {
  readonly maps = viewChildren<MapComponent>(MapComponent);
  public constructor(
    private dialog: MatDialog,
    public reference: MatDialogRef<PreviewZoneChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreviewZoneChangeData,
  ) {
    super();
    effect(() => {
      this.maps()?.forEach((map) => map.setAddress(this.data.address, false));
    });
  }

  public close(): void {
    this.reference.close(this.data.zone);
  }

  findDiff(
    scheduleZips: string[],
    zoneZips: string[],
  ): {
    plus: number;
    minus: number;
    plusZips: string[];
    minusZips: string[];
    commonZips: string[];
  } {
    const setScheduleZips = new Set(scheduleZips);
    const setZoneZips = new Set(zoneZips);

    const plusZips = [...setZoneZips].filter((x) => !setScheduleZips.has(x));
    const minusZips = [...setScheduleZips].filter((x) => !setZoneZips.has(x));
    const commonZips = [...setScheduleZips].filter((x) => setZoneZips.has(x));

    return {
      plus: plusZips.length,
      minus: minusZips.length,
      plusZips,
      minusZips,
      commonZips,
    };
  }

  editZone() {
    this.dialog
      .open(SaveZoneDialogComponent, {
        width: '700px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          title: 'Edit Zone',
          parentId: this.data.schedule.vehicle_id || this.data.schedule.store_id,
          address: this.data.address,
          zone: this.data.zone,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.data.zone = res;
          this.data = { ...this.data, ...this.findDiff(this.data.schedule.zips, this.data.zone.zips) };
        }
      });
  }
}
